export const getSessionStorageItem = (key: string) => {
  const data = sessionStorage.getItem(key);

  return data ? data : undefined;
};
